import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Logger } from '@studio/utils/logger';
import { AppComponent } from '../../app.component';
import { FontFamiliesService } from '../font-families/state/font-families.service';
import { CreativesetDataService } from './creativeset.data.service';

@Component({
    selector: 'creativeset-component',
    templateUrl: './creativeset.component.html'
})
export class CreativesetComponent implements OnDestroy {
    private logger = new Logger('CreativesetComponent');
    private unsubscribe$ = new Subject<void>();

    constructor(
        private app: AppComponent,
        private route: ActivatedRoute,
        private creativesetDataService: CreativesetDataService,
        private fontFamiliesService: FontFamiliesService
    ) {
        this.fontFamiliesService.fontFamilies$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(fontFamilies => {
                this.creativesetDataService.setFontFamilies(fontFamilies);
            });

        this.app.loaded = true;
    }

    ngOnDestroy(): void {
        this.logger.verbose('ngOnDestroy');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
